import React from 'react';
import Box from '@mui/joy/Box';

interface DrawerWithStickyFooterProps {
    children: React.ReactNode; // Main, scrollable content
    footer: React.ReactNode;   // Sticky footer content
}

export default function DrawerWithStickyFooter({ children, footer }: DrawerWithStickyFooterProps) {
    return (
        <Box
            role="presentation"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%', // Ensure the container takes full height
            }}
        >
            {/* Content area — children handle their own overflow */}
            <Box sx={{ flex: 1, overflow: 'hidden', minHeight: 0, p: 2, display: 'flex', flexDirection: 'column' }}>
                {children}
            </Box>

            {/* Sticky Footer */}
            <Box
                sx={{
                    p: 2,
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: '100%',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '10px',
                    // This ensures the footer doesn't shrink
                    flexShrink: 0,
                }}
            >
                {footer}
            </Box>
        </Box>
    );
}